import React from 'react'

export const ModalRoot: React.FC = () => {
  return <div id="modal-root" data-testid="modal-root" />
}
